import { FC } from 'react';
import { FileButton } from './FileButton';
import * as S from 'ui/Input/Input.styled';
import { FileFieldProps } from './FileButton.types';
import { InputMeta } from 'ui/Input/Meta';

export const FileField: FC<FileFieldProps> = ({
    input,
    meta,
    label,
    fileType,
    onChange,
    upload,
    errors
}) => {
    const content = (
        <FileButton
            onUpload={input.onChange}
            onChange={onChange}
            value={input.value}
            fileType={fileType}
            upload={upload}
        />
    );

    if (!label) {
        return content;
    }

    return (
        <S.Container>
            <S.Label>{label}</S.Label>
            {content}
            <S.MetaContainer>
                <InputMeta meta={meta} errors={errors} />
            </S.MetaContainer>
        </S.Container>
    );
};
